export function formatYmdFromDate(date: Date): string {
    const y = String(date.getFullYear())
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
}

export function formatYmdFromTimestamp(
    timestamp?: number | null,
    fallback?: string | null
): string {
    if (typeof timestamp === 'number' && !Number.isNaN(timestamp)) {
        return formatYmdFromDate(new Date(timestamp))
    }

    return fallback ?? ''
}

const DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

function formatYmd(year: number, month: number, day: number): string {
    const y = String(year);
    const m = String(month).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function addMonthsWithMonthEndClamp(dateStr?: string | null, months = 0): string {
    if (!dateStr) return '';
    const match = DATE_REGEX.exec(dateStr);
    if (!match) return dateStr;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);

    if (!year || !month || !day) return dateStr;

    const totalMonths = (year * 12 + (month - 1)) + months;
    const targetYear = Math.floor(totalMonths / 12);
    const targetMonthIndex = totalMonths % 12;
    const maxDayInTargetMonth = new Date(targetYear, targetMonthIndex + 1, 0).getDate();
    const targetDay = Math.min(day, maxDayInTargetMonth);

    return formatYmd(targetYear, targetMonthIndex + 1, targetDay);
}
